import React from 'react';
import PropTypes from 'prop-types';

export const Inactive = ({ width, height, ...props }) => (
  <svg
    data-icon='inactive'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M12 19c-1.933 0-3.583-.683-4.95-2.05C5.683 15.583 5 13.933 5 12c0-1.933.683-3.583 2.05-4.95C8.417 5.683 10.067 5 12 5c1.933 0 3.583.683 4.95 2.05C18.317 8.417 19 10.067 19 12c0 1.933-.683 3.583-2.05 4.95C15.583 18.317 13.933 19 12 19Zm0-2c1.383 0 2.563-.488 3.537-1.463C16.512 14.563 17 13.383 17 12s-.488-2.563-1.463-3.537C14.563 7.488 13.383 7 12 7s-2.563.487-3.537 1.463C7.488 9.438 7 10.617 7 12s.487 2.563 1.463 3.537C9.438 16.512 10.617 17 12 17Z'
    />
  </svg>
);

Inactive.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Inactive.defaultProps = {
  width: 24,
  height: 24,
};
